/**
 * 게임 모듈 레지스트리 싱글턴(결정 #25). 부팅 시 설치된 모듈을 등록하고, 세션은
 * `moduleId`로 자기 모듈을 찾는다. core의 GameModuleRegistry는 플랫폼 중립
 * 컨테이너이고, 여기서 web이 실제 모듈을 등록한다(결정 #10).
 *
 * 등록 순서가 모듈 선택 UI의 표시 순서다(결정 #25 list 순서 보존). 현재 등록:
 *  - 롤플레잉(자유대화, 모듈 #1) — 런타임 훅 없음(#28 가산성).
 *  - 텍스트 어드벤처/스탯 RPG/비주얼노벨/소셜 추리 — 네이티브 구조화 게임(#26 턴 프로토콜 +
 *    #27 viewSpec). 네 장르가 선택지·스탯·주사위·장면·투표 위젯을 각각 실증한다.
 *  - 방탈출 — 데이터형 모듈(#29). 코드 없이 GameDefinition 선언만으로 compileGameDefinition이
 *    만들어낸 모듈이라, 네이티브와 동일 계약으로 흐른다(데이터형 제작 사다리의 실증).
 * 향후 카드 IO(#6)·위저드(#29)로 들여온 정의도 같은 컴파일러를 거쳐 여기에 등록된다.
 */
import { GameModuleRegistry, ROLEPLAY_MODULE_ID, type GameModule } from "@roqeet/core";
import { textAdventureModule } from "../platform/game/text-adventure.js";
import { statRpgModule } from "../platform/game/stat-rpg.js";
import { visualNovelModule } from "../platform/game/visual-novel.js";
import { socialDeductionModule } from "../platform/game/social-deduction.js";
import { escapeRoomModule } from "../platform/game/escape-room.js";

/** 롤플레잉 모듈(모듈 #1). 매니페스트만 — 기존 채팅 UI가 그대로 이 모듈의 런타임
 *  역할을 한다. 자유대화라 런타임 훅(턴 프로토콜/viewSpec)이 없다 — 전송 파이프라인이
 *  훅 부재를 감지해 기존 자유대화 경로를 쓴다(#28 가산성). */
const roleplayModule: GameModule = {
  manifest: {
    id: ROLEPLAY_MODULE_ID,
    title: "롤플레잉",
    titleKey: "game.mod.roleplay.title",
    description: "캐릭터와 자유롭게 대화하는 AI 롤플레잉. 카드·로어북·스크립트 지원.",
    descriptionKey: "game.mod.roleplay.desc",
    kind: "native",
    icon: "chat",
  },
};

export const gameModules = new GameModuleRegistry();
gameModules.register(roleplayModule);
gameModules.register(textAdventureModule);
gameModules.register(statRpgModule);
gameModules.register(visualNovelModule);
gameModules.register(socialDeductionModule);
gameModules.register(escapeRoomModule);
